import { useMemo } from 'react';
import dayjs from 'dayjs';
import { useScheduleBoardContext } from 'pos-client/components/scheduleBoard/context/ScheduleBoardContext.tsx';
import { dayJsWeekdayAsString } from 'pos-client/utils/dateHelpers.ts';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useResources = () => {
  const { selectedLocation, selectedDate, serviceTypeFilter } =
    useScheduleBoardContext();
  const dateIsValid = dayjs(selectedDate).isValid();

  const { data: resourceData, isFetching: resourceDataIsLoading } =
    trpc.getResourcesByLocationId.useQuery(
      {
        serviceLocationId: selectedLocation?.id ?? '',
        dateOfService: dateIsValid
          ? dayjs(selectedDate).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
        serviceType: serviceTypeFilter,
        sortAscending: true,
        pageSize: 20,
      },
      {
        enabled: !!selectedLocation?.id,
      }
    );

  const resourceDataSorted = useMemo(() => {
    if (!resourceData) return undefined;

    const weekday = dayJsWeekdayAsString(dayjs(selectedDate));

    const sortedResults = [...(resourceData.results ?? [])].sort((a, b) => {
      const aIsDefault = (a.defaultDays ?? []).includes(weekday);
      const bIsDefault = (b.defaultDays ?? []).includes(weekday);

      if (aIsDefault === bIsDefault) return 0;

      return aIsDefault ? -1 : 1;
    });

    return {
      ...resourceData,
      results: sortedResults,
    };
  }, [resourceData, selectedDate]);

  return {
    resourceData: resourceDataSorted,
    resourceDataIsLoading,
  };
};
